<template>
  <div class="w-full">
    <Modal
      :title="$t('NoneOfMatchTitle')"
      v-model="props.isModal"
      :isShowClose="false"
      containerClass="w-2/5 max-w-[600px]  p-2"
    >
      <template #bodyContent>
        <div class="flex flex-col">
          <div>{{ $t('saveFillForConvenienceContent') }}</div>
        </div>
      </template>
      <template #footerContent>
        <div class="flex justify-end items-center">
          <FilledButton
            class="px-5 py-1.5 text-white flex gap-2 items-center"
            @click.prevent="onConfirm"
          >
            {{ $t('GotIt') }}
          </FilledButton>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import Modal from '@/components/Ui/Modal/index.vue'

import FilledButton from '@/components/Buttons/Filled.vue'

const emits = defineEmits(['onClose', 'confirm'])
const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  }
})

const onConfirm = () => {
  emits('confirm')
}
</script>
<script>
export default {
  name: 'NoneOfMatchModal'
}
</script>
